import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-file-preview-btn',
  templateUrl: './file-preview-btn.component.html',
  styleUrls: ['./file-preview-btn.component.scss'],
})
export class FilePreviewBtnComponent {
  @Input() file_path?: string;
}
